import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import Style from './Complete.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import Media from '../CommonSet/Media';

class Complete extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        const { isMazeMode = false, isLastStudy = false } = entrylms.getData();
        this.isMazeMode = isMazeMode;
        this.isLastStudy = isLastStudy;
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'COMPLETE');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    getTitleName() {
        let option = '';

        if (this.props.item.titleType) {
            option = ` ${this.props.item.titleType}`;
        }

        return `${this.Style.title} ${option}`;
    }

    createMediaView() {
        let view = null;

        if (this.props.item.media) {
            view = (
                <Media
                    className={this.Style.media}
                    media={this.props.item.media}
                    option={{
                        width: 308,
                        height: 190,
                    }}
                />
            );
        }

        return view;
    }

    createCustomButton() {
        const { buttons = [] } = this.props.item;

        const customButtons = buttons.map((button, i) => {
            return (
                <Button
                    key={`customButton${i}`}
                    className={this.Style.button}
                    text={button.text}
                    onClick={(e) => button.click(e)}
                />
            );
        });
        if(customButtons) {
            return <div>{customButtons}</div>;
        }
        return null;
    }

    render() {
        const {
            isHomework,
            isHomeworkLapse,
            isSubmit,
            isLastStudy,
            media = {},
        } = this.props.item;
        return (
            <div className={`${this.Style.complete} ${media.category || ''}`}>
                <Title className={this.getTitleName()} isClose={false}>
                    {this.props.item.title}
                </Title>
                <div className={this.Style.contentView}>
                    <div className={this.Style.content}>
                        {this.createMediaView()}
                        <div
                            dangerouslySetInnerHTML={{
                                __html: this.props.item.content,
                            }}
                        />
                    </div>
                    <div className={this.Style.buttonGroup}>
                    {isHomework &&
                        !isHomeworkLapse &&
                        (isSubmit || (this.isMazeMode && this.isLastStudy)) && (
                            <Button
                                className={this.Style.button}
                                text={this.Utils.getLang(
                                    'Buttons.course_submit'
                                )}
                                onClick={() => this.handleButtonClick('submit')}
                            />
                        )}
                    {this.props.item.titleType !== 'FAIL' &&
                        (!this.isMazeMode ||
                            (this.isMazeMode &&
                                (!isLastStudy || !isHomework))) && (
                            <Button
                                className={this.Style.button}
                                text={
                                    !isLastStudy
                                        ? this.Utils.getLang(
                                              'Buttons.next_lesson'
                                          )
                                        : this.Utils.getLang(
                                              'Menus.course_done_study'
                                          )
                                }
                                onClick={() => this.handleButtonClick('next')}
                            />
                        )}
                    {this.createCustomButton()}
                    <Button
                        className={this.Style.prevButton}
                        onClick={() => this.handleButtonClick('prev')}
                    >
                        <div className={this.Style.text}>
                            {this.Utils.getLang('Buttons.previous')}
                        </div>
                    </Button>
                    </div>
                </div>
            </div>
        );
    }
}

Complete.displayName = 'Complete';
Complete.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Complete);



// WEBPACK FOOTER //
// ./components/ModalSet/Complete.js